import React from 'react';
import { XSLoadingSpinner } from '../../../xs/component/loading/spinner/XSLoadingSpinner';

export function BlockLoader() {
    return (
        <div style={{ height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <XSLoadingSpinner />
        </div>
    );
}
